import { PRODUCT_EN_BY_ID, PRODUCT_ZH_NAME_TO_ID } from '../i18n/productTranslations';

function resolveEnglishBundle(product) {
  const rawId = product?.id;
  const numId = rawId === '' || rawId == null ? NaN : Number(rawId);
  const nameKey = product?.name != null ? String(product.name).trim() : '';
  const nameId = nameKey ? PRODUCT_ZH_NAME_TO_ID[nameKey] : undefined;
  // 优先按中文名匹配（避免库里 id 与种子顺序不一致时错用英文）
  if (nameId != null) {
    const byName = PRODUCT_EN_BY_ID[nameId];
    if (byName) return byName;
  }
  if (Number.isFinite(numId)) {
    return PRODUCT_EN_BY_ID[numId];
  }
  return undefined;
}

/**
 * 按界面语言覆盖商品的 name / description / details（仅英文走前端映射）
 */
export function localizeProduct(product, locale) {
  if (!product || locale !== 'en') {
    return product;
  }
  const en = resolveEnglishBundle(product);
  if (!en) {
    return product;
  }
  return {
    ...product,
    name: en.name || product.name,
    description: en.description != null ? en.description : product.description,
    details: en.details != null ? en.details : product.details,
  };
}

export function localizeProducts(list, locale) {
  if (!list || locale !== 'en') {
    return list;
  }
  return list.map((p) => localizeProduct(p, locale));
}
